import React, {Component, Fragment} from 'react';
import {Button, Input, InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';
import {connect} from 'react-redux';
import * as checkpoints from 'catalog/actions/checkpoints';
import DeleteCheckpoint from 'catalog/components/DeleteCheckpoint';
import MoveCheckpoint from 'catalog/components/MoveCheckpoint';
import autobind from 'autobind-decorator';
import MeasureList from '../containers/MeasureList';

@connect(
    state => ({
        activeCheckpoint: state.categories.activeCheckpoint
    }),
    dispatch => ({
        updateCheckpoint: (checkpoint) => dispatch(checkpoints.updateCheckpoint(checkpoint)),
        deleteCheckpoint: (checkpoint) => dispatch(checkpoints.removeCheckpoint(checkpoint)),
        selectCheckpoint: (checkpoint) => dispatch(checkpoints.selectCheckpoint(checkpoint))
    })
)
export default class Checkpoint extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkpoint: props.checkpoint,
        };
    }

    @autobind
    selectCheckpoint() {
        this.props.selectCheckpoint(this.state.checkpoint)
    }

    @autobind
    changeName(e) {
        this.setState({checkpoint: {...this.state.checkpoint, name: e.target.value}})
    }

    @autobind
    saveCheckpoint() {
        if (this.props.checkpoint.name === this.state.checkpoint.name)
            return;
        this.props.updateCheckpoint({...this.props.checkpoint, ...this.state.checkpoint})
    }

    @autobind
    isActive() {
        const {checkpoint, activeCheckpoint} = this.props
        return !!activeCheckpoint && activeCheckpoint.id === checkpoint.id
    }

    render() {
        const id = this.props.id;
        const isActive = this.isActive()
        return (
            <Fragment>
                <li style={{'marginBottom': '1em'}}>
                    <InputGroup>
                        <InputGroupAddon addonType='prepend'>
                            <InputGroupText style={{'width': '3em'}}>
                                {id + 1}.
                            </InputGroupText>
                        </InputGroupAddon>
                        <InputGroupAddon addonType='prepend'>
                            <Button
                                color='primary'
                                onClick={this.selectCheckpoint}
                            >

                                <i className={'fa fa-folder-open'}> </i>
                            </Button>
                        </InputGroupAddon>
                        <Input value={this.state.checkpoint.name} onChange={this.changeName}
                               onBlur={this.saveCheckpoint}
                               type='textarea'/>
                        <InputGroupAddon addonType='append'>
                            <MoveCheckpoint checkpoint={this.state.checkpoint}/>
                            <DeleteCheckpoint checkpoint={this.state.checkpoint}/>
                        </InputGroupAddon>
                    </InputGroup>
                </li>
                {
                    isActive &&
                    <MeasureList/>

                }
            </Fragment>
        )
    }
}

